module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/108.53bbeeaf.png";